import { addReferenceUtil } from '../../../../../references/utils'

export function addReferenceReduxReducerUtil (params) {
  const {
    instance,
    referencePath,
    state
  } = params

  // Add the referencePath to the list of paths referencing the pointer
  const addReferenceObj = addReferenceUtil({
    instance,
    referencePath,
    state
  })

  if (!addReferenceObj) {
    return state
  }

  return addReferenceObj.state
}
